import { Navigate } from "react-router-dom";
import { useAuth } from "../../services/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { isLoggedIn } = useAuth();
  // If the user is not logged in, redirect to login
  if (!isLoggedIn) {
    return <Navigate to="/" replace />;
  }
  // If logged in, render the protected route
  return children;
};

export default ProtectedRoute;
